/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */


/* Components */
import UCButton from "../../buttons";


/* Styles */
import styles from "./styles.js"


const Content = props => {
  const {setShowModal, row, getLoyaltyList, addRedemption, updateRedemptionsList} = props;
  const theme = useTheme();
  const classes = styles({ theme });

  const data = {
    redemptions: [
      {
        userEntityId: row.recipientId,
        tierLevel: row.tierLevelId.toString(),
        redemptionId: row.redemptionId,
      }
    ]
  }


  const handleResubmitRedemption = async () => {
    const success = await addRedemption(row.allotmentId, data);
    if (success) {
      setShowModal(false);
      if (typeof getLoyaltyList === 'function') getLoyaltyList();
      if (typeof updateRedemptionsList === 'function') updateRedemptionsList();
    }
  }

  return (
    <div className={classes.modalContent}>
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="resubmitRedeptionModal.cancel"/>}
              />
            </Col>
            <Col className={classes.colRemove} >
              <UCButton
                className={classes.createBtn}
                onClick={() => handleResubmitRedemption()}
                type="primary"
                text={<FormattedMessage id="resubmitRedeptionModal.resubmit"/>}
                spinner={{
                  name: "addRedemptionSpinner",
                  size: 20,
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default Content;
